module.exports = __webpack_public_path__ + "img/South-Korea.f6e26211.jpg";